(function (angular, schoolwork12) {
    
    'use strict';
    angular.module(schoolwork12.app.student.name)

    .factory(schoolwork12.app.student.services.studentSaveSearch, 
        ['$rootScope', '$http', '$uibModal','$q', schoolwork12.app.auth.services.authentication,
        function($rootScope, $http, $uibModal, $q, authentication) {      

        var resultList = []; 
        var saveSearchCopy = false;
        // var updateFlag = false;   
  		var service  = function studentSaveSearch(searchRequestPayload, selectedItem, updateFlag, adminAccess) {
			var modalInstance = $uibModal.open({
			    templateUrl: schoolwork12.app.student.templates.studentSaveSearch,
			    size: 'lg',
			    backdrop: 'static',
			    resolve: {
                    resultList: function() {
                        return resultList;
                    }
                },
			    controller: ['$scope', '$uibModalInstance',			   
		        function ($scope, $uibModalInstance) {
		       		console.log("Save Search for Students");
				
			    //initialize default settings
			    $scope.forms = {};
			    $scope.saveSearchErrorMesg = "";
			    $scope.saveSearchErrorOccurred = false;
			    $scope.isSaveStudentBusy = false;
                $scope.isAdmin = adminAccess;	

				$scope.cancel = function () {
				    $uibModalInstance.dismiss('cancel');
				};

				$scope.closeErrorMsg = function() {
                    $scope.saveSearchErrorOccurred = false;
                } 

                console.log("selectedItem", selectedItem); 
                console.log("updateFlag", updateFlag);

                if (authentication.isAuthenticated()) {
                    $scope.schoollist = authentication.getSchools();
                }

                $scope.rolelist = [
                    { "name": 'Administrator', "roleId": 1003 },
                    { "name": 'Teacher', "roleId": 1002 },
                    { "name": 'Enrollment Advisor', "roleId": 1004 }
                ]

                //fetch selSchoolList and selRoleList from id's
                    var selSchoolIds = selectedItem.shareSchoolId;
                    var selSchoolList = [];
                    for (var i in $scope.schoollist) {
                     for (var j in selSchoolIds) { 
                        if (selSchoolIds[j] == $scope.schoollist[i].schoolId) {
                        selSchoolList.push($scope.schoollist[i]);
                        }
                     }
                    }

                    var selRoleIds = selectedItem.shareRoleId;
                    var selRoleList = [];
                    for (var i in $scope.rolelist) {
                     for (var j in selRoleIds) { 
                        if (selRoleIds[j] == $scope.rolelist[i].roleId) {
                        selRoleList.push($scope.rolelist[i]);
                        }
                     }
                    }

                if(selectedItem){
                     $scope.saveSrch = {
                         "name": selectedItem.name,
                         "desc": selectedItem.description,
                         "id": selectedItem.id,
                         "schoollist": updateFlag ? selSchoolList : [],
                         "rolelist": updateFlag ? selRoleList : [],
                         "isShareSearchChecked": selectedItem.shareSave
                    };   
                }

                if((saveSearchCopy.id === selectedItem.id) && updateFlag){
                    $scope.saveSrch = {
                         "name": saveSearchCopy.name,
                         "desc": saveSearchCopy.description,
                         "id": saveSearchCopy.id,
                         "schoollist": selSchoolList,
                         "rolelist": selRoleList,
                         "isShareSearchChecked": selectedItem.shareSave
                    };
                    console.log("$scope.saveSrch update existing", $scope.saveSrch, updateFlag)
                } 

            //NgTagsInput Start - Schools
            $scope.allTagsAdded = [];
            var notShareSchoolId = [];
            var notShareRoleId = [];

            $scope.loadTags = function ($query) {
                $query = $query.trim();
                var defer = $q.defer();
                $scope.schoollist = authentication.getSchools();
                var schoolList = $scope.schoollist;
                var matchingTags = $scope.schoollist;  

                    if($scope.allTagsAdded.length > 0){
                        matchingTags = $scope.removeDuplicatesTags(matchingTags);                         
                    }   

                    if ($query.length >= 1) {
                        matchingTags = matchingTags.filter(function (item) {
                            return item.abbreviation.toLowerCase().indexOf($query.toLowerCase()) != -1;
                        });                       
                        if (matchingTags.length <= 0) {
                                matchingTags = [{
                                    "abbreviation": "Oops, nothing found! " + "'" + $query + "'"
                                }];
                        }
                    }
                    defer.resolve(matchingTags);
                    return defer.promise;
                  };
                    
                $scope.removeDuplicatesTags = function(tagsArray){
                    for(var i=1, len = $scope.allTagsAdded.length; i<len; i++){
                        for(var j=1, length= tagsArray.length; j<length; j++){
                            if(tagsArray[j].abbreviation.toLowerCase() == $scope.allTagsAdded[i].abbreviation.toLowerCase()){
                                tagsArray.splice(j,0);
                                break;
                            }        
                        }            
                    }
                    return tagsArray;
                };
                    
                $scope.tagAdded = function(tag, schoolArray){ 
                    if (tag.abbreviation.indexOf("Oops, nothing found!") !== -1) {
                        schoolArray.pop(tag);                   
                    } else {
                        $scope.allTagsAdded.push(tag);
                    }
                };
                    
                $scope.tagRemoved = function(tag){
                    console.log("schools removed", tag);
                    notShareSchoolId.push(tag);
                    $scope.allTagsAdded = $scope.allTagsAdded.filter(function(item){
                        return item.abbreviation.toLowerCase() !== tag.abbreviation.toLowerCase();
                    });
                };
                //NG-TAGS-INPUT END

            //NgTagsInput Start - Roles
            $scope.allRoleTagsAdded = [];
            $scope.loadRoleTags = function ($query) {
                $query = $query.trim();
                var defer = $q.defer();
             
                var rolelist = $scope.rolelist;
                var matchingRoleTags = $scope.rolelist;  

                    if($scope.allRoleTagsAdded.length > 0){
                        matchingRoleTags = $scope.removeDuplicatesRoleTags(matchingRoleTags);                         
                    }   

                    if ($query.length >= 1) {
                        matchingRoleTags = matchingRoleTags.filter(function (item) {
                            return item.name.toLowerCase().indexOf($query.toLowerCase()) != -1;
                        });                       
                        if (matchingRoleTags.length <= 0) {
                                matchingRoleTags = [{
                                    "name": "Oops, nothing found! " + "'" + $query + "'"
                                }];
                        }
                    }
                    defer.resolve(matchingRoleTags);
                    return defer.promise;
                  };
                    
                $scope.removeDuplicatesRoleTags = function(tagsArray){
                    for(var i=1, len = $scope.allRoleTagsAdded.length; i<len; i++){
                        for(var j=1, length= tagsArray.length; j<length; j++){
                            if(tagsArray[j].name.toLowerCase() == $scope.allRoleTagsAdded[i].name.toLowerCase()){
                                tagsArray.splice(j,0);
                                break;
                            }        
                        }            
                    }
                    return tagsArray;
                };
                    
                $scope.tagRoleAdded = function(tag, schoolArray){ 
                    if (tag.name.indexOf("Oops, nothing found!") !== -1) {
                        schoolArray.pop(tag);                   
                    } else {
                        $scope.allRoleTagsAdded.push(tag);
                    }
                };
                    
                $scope.tagRoleRemoved = function(tag){
                    console.log("roles removed", tag)
                    notShareRoleId.push(tag);
                    $scope.allRoleTagsAdded = $scope.allRoleTagsAdded.filter(function(item){
                        return item.name.toLowerCase() !== tag.name.toLowerCase();
                    });
                };
                //NG-TAGS-INPUT END

				$scope.studentSaveSearch = function(){
					resetErrorFlags();
					$scope.isSaveStudentBusy = true;
                    $rootScope.saveSearchSuccess = false;

                    var sharedSchoolIds = _.pluck($scope.saveSrch.schoollist, 'schoolId');
                    var sharedRoleIds = _.pluck($scope.saveSrch.rolelist, 'roleId');

                    var notShareSchoolIdList = _.pluck(notShareSchoolId, 'schoolId');
                    var notShareRoleIdList = _.pluck(notShareRoleId, 'roleId');
                
                    if ($scope.isFormValid()) {
             	    // save student's search
                    	$http({
			              	url : schoolwork12.app.student.endpoints.saveStudentSearch,
                            method : updateFlag ? "PUT" : "POST",
			              	data : {
			              			name: $scope.saveSrch.name,
			              			description: $scope.saveSrch.desc,
                                    id: $scope.saveSrch.id,
                                    shareSchoolId: $scope.saveSrch.isShareSearchChecked ? sharedSchoolIds : [],
                                    shareRoleId: $scope.saveSrch.isShareSearchChecked ? sharedRoleIds : [],
                                    notShareSchoolId: $scope.saveSrch.isShareSearchChecked ? notShareSchoolIdList : [],
                                    notShareRoleId: $scope.saveSrch.isShareSearchChecked ? notShareRoleIdList : [],
                                    shareSave: $scope.saveSrch.isShareSearchChecked,
			              			studentSearchRequest: searchRequestPayload,
                                    status: 1
								    },
		        		  	headers : {
										'X-API-TOKEN' : authentication.getCurrentUser().keycode,
									}
			              	}).then(function (response) {
			              		console.info("Saved students search", response.data);
	            	   			$scope.saveSearchErrorOccurred = false;
	            	   			$rootScope.actionCompletedSuccessfully = true;
	            	   			$rootScope.actionCompletedSuccessfullyMessage = "You have successfully saved search."

                                if(~($rootScope.actionCompletedSuccessfullyMessage).indexOf("successfully saved search")){
                                        $rootScope.saveSearchSuccess = true;
                                } 
                                
	            	   			var str=response.data;
	            	   			var resultVal = function(input){
									var n=str.split(input + ':')
									var a = n[1];
									var arr = [];            
									a = a.split(' ');    
									arr.push(a.shift());  
									return a[0].replace(/[']/g, "");
	            	   			}

	            	   			$scope.searchId = resultVal("id");
	            	   			$scope.ownerId = resultVal("Person ID");
	            	   			
							    var n=str.split("name");
							    $scope.ownerName = n[1].replace(/['.]/g, "");

			              		var savedObj = {
			                      "ownerId": $scope.ownerId,
			                      "ownerName": $scope.ownerName,
			                      "name": $scope.saveSrch.name,
			                      "description": $scope.saveSrch.desc,
			                      "content": searchRequestPayload,
			                      "id": $scope.searchId,
                                  "shareSchoolId": $scope.saveSrch.isShareSearchChecked ? sharedSchoolIds : [],
                                  "shareRoleId": $scope.saveSrch.isShareSearchChecked ? sharedRoleIds : [],
                                  "notShareSchoolId": $scope.saveSrch.isShareSearchChecked ? notShareSchoolIdList : [],
                                  "notShareRoleId": $scope.saveSrch.isShareSearchChecked ? notShareRoleIdList : [],
                                  "shareSave": $scope.saveSrch.isShareSearchChecked,
			                    };

                                saveSearchCopy = angular.copy(savedObj);
                                console.log("saveSearchCopy", saveSearchCopy);

			                resultList.push(savedObj); 
                            var finalList = resultList.reverse();
			                $rootScope.savedSearchObj = finalList;

                        	$uibModalInstance.close(resultList);
                        	console.log("resultList", resultList);
			              	
                        	}, function(error) {
			              		$scope.saveSearchErrorOccurred = true;
			                	console.info('Error in saving Search...'.concat(angular.toJson(error)));
			                	if (error.status == 400) {
			                		for ( var j = 0; j < error.data._errors.length; j++) {
	                                    $scope.saveSearchErrorMesg = $scope.saveSearchErrorMesg + error.data._errors[j] + "\n";
	                                }

	                                var checkErrorMsg = $scope.saveSearchErrorMesg;
			                		//display errors based on back end error msgs
	                                if(~checkErrorMsg.indexOf("exceeded the maximum")){
	                                	$scope.saveSearchErrorMesg = schoolwork12.app.student.modalErrMessages.saveSearchMaxLimit;
	                                } else if(~checkErrorMsg.indexOf("unique name")){
	                                	$scope.saveSearchErrorMesg = schoolwork12.app.student.modalErrMessages.saveSearchDuplicateName;
	                                } else {
	                                	$scope.saveSearchErrorMesg = schoolwork12.app.student.modalErrMessages.saveSearchError;
	                                }

								} else if (error.status == 401 || error.status == 403) {
			                        $scope.saveSearchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
			                    } else {
			                        $scope.saveSearchErrorMesg = schoolwork12.app.errorMessages.internalError;
			                    }
			            	});

                    } else {
                    	$scope.isSaveStudentBusy = false;
                    }
				}

				$scope.isFormValid = function(){
					//validations for form fields
					console.info("Validating save search name");
					if ($scope.saveSrch.name == null ||
					    $scope.saveSrch.name== "") {
						$scope.saveSearchErrorName = true;
						$scope.saveSearchNameMesg = schoolwork12.app.student.errorMessages.saveSrchNameRequired;
					}

                if($scope.saveSrch.isShareSearchChecked){
                    console.info("Validating save search schools");
                    if ($scope.saveSrch.schoollist == null ||
                        $scope.saveSrch.schoollist.length == 0) {
                        $scope.saveSearchErrorSchool = true;
                        $scope.saveSearchSchoolMesg = schoolwork12.app.student.errorMessages.saveSrchSchoolRequired;
                    }

                    console.info("Validating save search roles");
                    if ($scope.saveSrch.rolelist == null ||
                        $scope.saveSrch.rolelist.length == 0) {
                        $scope.saveSearchErrorRole = true;
                        $scope.saveSearchRoleMesg = schoolwork12.app.student.errorMessages.saveSrchRoleRequired;
                    }
                }

					return !$scope.saveSearchErrorName && !$scope.saveSearchErrorSchool && !$scope.saveSearchErrorRole
				}
				
				var resetErrorFlags = function() {
                    // Control Error messages 
                    $scope.saveSearchErrorMesg = "";
                    $scope.saveSearchErrorOccurred = false; 
                   
                    $scope.saveSearchNameMesg = "";
                    $scope.saveSearchErrorName = false; 

                    $scope.saveSearchSchoolMesg = "";
                    $scope.saveSearchErrorSchool = false;  

                    $scope.saveSearchRoleMesg = "";
                    $scope.saveSearchErrorRole = false; 
                    	
                    $rootScope.actionCompletedSuccessfully = false;
	            	$rootScope.actionCompletedSuccessfullyMessage = "";
                }

			}],
		  	    
		});
	};

			//build and getSavedStudentObj
			var getSavedStudentObj = function(item, list, attAccess){
                var invalidFieldList = [];
                var invalidFieldNameList = [];  

                var clean = function(obj) {
                  for (var propName in obj) { 
                    if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
                      delete obj[propName];
                    }
                  }
                }

                clean(item.content);

                //build invalidFieldList
                if(list){
                    for(var i = 0;  i < list.length; i++){
                        if(_.has(item.content, list[i].uivarname) && (list[i].value == false || !attAccess)){
                            invalidFieldNameList.push(list[i].name);
                        }

                        if (list[i].value == false && list[i].uivarname!=undefined){
                            invalidFieldList.push(list[i].uivarname);
                        }
                    }
                }
                var itemObj = {};

                angular.copy(item.content, itemObj);
                //delete invalidfields
                var deleteFromObject = function(keyPart, obj){
                    for (var k in obj){          
                       // if( ~k.indexOf(keyPart)){
                       if( k === keyPart) {
                            delete obj[k];       
                        }
                        if( k === keyPart+"Qualifier" ) {
                            delete obj[k];       
                        }
                    }
                }

                //build item.content
                if(invalidFieldList){
                     for(var i = 0;  i < invalidFieldList.length; i++){
                        deleteFromObject(invalidFieldList[i], itemObj);
                    }
                }

                invalidFieldNameList = invalidFieldNameList.join(", ");

                if(invalidFieldNameList.length > 0){
                    $rootScope.invalidFieldsWarning = true;
                    $rootScope.invalidFieldsWarningMessage = "The following fields could not be successfully loaded to the search pane from the saved search that you have selected: " + invalidFieldNameList;
                } else {
                    $rootScope.invalidFieldsWarning = false;
                    $rootScope.invalidFieldsWarningMessage = "";
                }

                var savedStudentObj = {
                    "firstName": itemObj.firstName,
                    "lastName": itemObj.lastName,
                    "studentId": itemObj.studentIds,
                    "status": itemObj.status,
                    "grade": itemObj.gradeLevels ? itemObj.gradeLevels.split(',') : '',
                    "school": itemObj.schoolIds ? itemObj.schoolIds.split(',') : '',
                
                    "isDemoDataChecked": (itemObj.categories) ? (itemObj.categories).includes("demographic") : false,
                    "demoData": {
                        "identityId": (itemObj.identityId) ? parseInt(itemObj.identityId) : '',
                        "familyId": itemObj.familyId,
                        "studentType": (itemObj.type) ? (itemObj.type.toString().charAt(0).toUpperCase() + itemObj.type.toString().slice(1)) : '',
                        "enrollmentDateQualifier": itemObj.enrollmentDateQualifier,
                        "enrollmentDate": itemObj.enrollmentDate,
                        "schoolWithdrawalDateQualifier": itemObj.schoolWithdrawalDateQualifier,
                        "schoolWithdrawalDate": itemObj.schoolWithdrawalDate,
                        "enrollmentReceivedDateQualifier": itemObj.enrollmentReceivedDateQualifier,
                        "enrollmentReceivedDate": itemObj.enrollmentReceivedDate,
                        "enrollmentApprovedDateQualifier": itemObj.enrollmentApprovedDateQualifier,
                        "enrollmentApprovedDate": itemObj.enrollmentApprovedDate,
                        "fullTime": itemObj.fullTime,
                        "fundingModel": itemObj.fundingModel,
                        "fte": itemObj.fte,
                        "personalGroups": itemObj.personalGroups ? itemObj.personalGroups.split(',').map(Number) : '',
                        "spPrograms": itemObj.specialPrograms ? itemObj.specialPrograms.split(',') : '',
                        "participantProgram": itemObj.participantProgram ? itemObj.participantProgram.split(',') : '',
                        "currentCteProgram": itemObj.currentCteProgram ? itemObj.currentCteProgram.split(',') : '',
                        "futureCteProgram": itemObj.futureCteProgram ? itemObj.futureCteProgram.split(',') : '',
                        "familyLanguage": itemObj.familyLanguage,
                        "studentLanguage": itemObj.studentLanguage
                    },

                    "isAttendanceChecked": (itemObj.categories) ? (itemObj.categories).includes("attendance") : false,
                    "attendance": {
                        "excludeStFromAtt": (itemObj.excludeStFromAtt) ? (itemObj.excludeStFromAtt.toString().charAt(0).toUpperCase() + itemObj.excludeStFromAtt.toString().slice(1)) : '',
                        "attendance1stDayQualifier": itemObj.attendance1stDayQualifier,
                        "attendance1stDay": itemObj.attendance1stDay,
                        "attendanceLastDayQualifier": itemObj.attendanceLastDayQualifier,
                        "attendanceLastDay": itemObj.attendanceLastDay,
                        "consecutiveDaysAbsentQualifier": itemObj.consecutiveDaysAbsentQualifier,
                        "consecutiveDaysAbsent": itemObj.consecutiveDaysAbsent,
                        "truancyDateQualifier": itemObj.truancyDateQualifier,
                        "truancyDate": itemObj.truancyDate,
                        "percentAttendedQualifier": itemObj.percentAttendedQualifier,
                        "percentAttended": itemObj.percentAttended,
                        "totalDaysEnrolledQualifier": itemObj.totalDaysEnrolledQualifier,
                        "totalDaysEnrolled": itemObj.totalDaysEnrolled,
                        "daysPresentQualifier": itemObj.daysPresentQualifier,
                        "daysPresent": itemObj.daysPresent,
                        "daysAbsentQualifier": itemObj.daysAbsentQualifier,
                        "daysAbsent": itemObj.daysAbsent,
                        "totalHrsQualifier": itemObj.totalHrsQualifier,
                        "totalHrs": itemObj.totalHrs,
                        "lastLessonQualifier": itemObj.lastAttemptedLessonQualifier,
                        "lastLesson": itemObj.lastAttemptedLesson,
                        "missingHrsQualifier": itemObj.missingHrsQualifier,
                        "missingHrs": itemObj.missingHrs,
                        "attHrs4WeekQualifier": itemObj.attHrs4WeekQualifier,
                        "attHrs4Week": itemObj.attHrs4Week,
                        "attHrsMissing4WeekQualifier": itemObj.attHrsMissing4WeekQualifier,
                        "attHrsMissing4Week": itemObj.attHrsMissing4Week,
                        "attLast7DaysQualifier": itemObj.attLast7DaysQualifier,
                        "attLast7Days": itemObj.attLast7Days,
                        "attMissingLast7DaysQualifier": itemObj.attMissingLast7DaysQualifier,
                        "attMissingLast7Days": itemObj.attMissingLast7Days,
                        "att4WeekQualifier": itemObj.att4WeekQualifier,
                        "att4Week": itemObj.att4Week,
                        "attMissing4WeekQualifier": itemObj.attMissing4WeekQualifier,
                        "attMissing4Week": itemObj.attMissing4Week,
                        "totalOnlineTimeQualifier": itemObj.totalOnlineTimeQualifier,
                        "totalOnlineTime": itemObj.totalOnlineTime,
                        "totalOfflinetimeQualifier": itemObj.totalOfflinetimeQualifier,
                        "totalOfflinetime": itemObj.totalOfflinetime,
                        "missingOverHrsQualifier": itemObj.missingOverHrsQualifier,
                        "missingOverHrs": itemObj.missingOverHrs,
                        "absentSchoolDays": itemObj.absentSchoolDays,
                        "makeupDays": itemObj.makeupDays,
                        "excusedAbsences": itemObj.excusedAbsences,
                        "att4SemQualifier": itemObj.att4SemQualifier,
                        "att4Sem": itemObj.att4Sem,
                        "missing4SemQualifier": itemObj.missing4SemQualifier,
                        "missing4Sem": itemObj.missing4Sem,
                        "firstDayAttModifiedQualifier": itemObj.firstDayAttModifiedQualifier,
                        "firstDayAttModified": itemObj.firstDayAttModified,
                        "nonConfirmedAbsences": itemObj.nonConfirmedAbsences,
                        "lcOnlyDays": itemObj.lcOnlyDays,
                        "unexcusedAbsenceDays": itemObj.unexcusedAbsenceDays,
                        "unexcusedAbsencesQualifier": itemObj.unexcusedAbsencesQualifier,
                        "unexcusedAbsences": itemObj.unexcusedAbsences,
                        "excusedHrsQualifier": itemObj.excusedHrsQualifier,
                        "excusedHrs": itemObj.excusedHrs ,
                        "unexcusedHrsQualifier": itemObj.unexcusedHrsQualifier,
                        "unexcusedHrs": itemObj.unexcusedHrs,
                        "numberOfExcusedAbsences": itemObj.numberOfExcusedAbsences,
                        "numberOfExcusedAbsencesQualifier": itemObj.numberOfExcusedAbsencesQualifier,
                        "attLast14Days": itemObj.attLast14Days,
                        "attLast14DaysQualifier": itemObj.attLast14DaysQualifier,
                        "attForTerm": itemObj.attForTerm,
                        "attForTermQualifier": itemObj.attForTermQualifier,
                        "missingHoursLastMonth": itemObj.missingHoursLastMonth,
                        "missingHoursLastMonthQualifier": itemObj.missingHoursLastMonthQualifier,
                        "missingHoursCurrentMonth": itemObj.missingHoursCurrentMonth,
                        "missingHoursCurrentMonthQualifier": itemObj.missingHoursCurrentMonthQualifier

                    },

                    "isMTSSLevelsChecked": (itemObj.categories) ? (itemObj.categories).includes("mtsslevels") : false,
                        	"mtsslvls": {
                                    "ELALevel": itemObj.elaMtssLvlId=="1"||itemObj.elaMtssLvlId=="Tier 2"? "Tier 2": itemObj.elaMtssLvlId=="2"||itemObj.elaMtssLvlId=="Tier 3"? "Tier 3": itemObj.elaMtssLvlId=="0"||itemObj.elaMtssLvlId=="Not Selected"? "Not Selected": "",
                                        "MathLevel": itemObj.mathMtssLvlId=="1"||itemObj.mathMtssLvlId=="Tier 2"? "Tier 2": itemObj.mathMtssLvlId=="2"||itemObj.mathMtssLvlId=="Tier 3"? "Tier 3": itemObj.mathMtssLvlId=="0"||itemObj.mathMtssLvlId=="Not Selected"?"Not Selected":"",
                                        "ScienceLevel": itemObj.scienceMtssLvlId=="1"||itemObj.scienceMtssLvlId=="Tier 2"? "Tier 2": itemObj.scienceMtssLvlId=="2"||itemObj.scienceMtssLvlId=="Tier 3"? "Tier 3": itemObj.scienceMtssLvlId=="0"||itemObj.scienceMtssLvlId=="Not Selected"?"Not Selected":"",
                                        "HistoryLevel": itemObj.ssHistoryMtssLvlId=="1"||itemObj.ssHistoryMtssLvlId=="Tier 2"? "Tier 2": itemObj.ssHistoryMtssLvlId=="2"||itemObj.ssHistoryMtssLvlId=="Tier 3"? "Tier 3": itemObj.ssHistoryMtssLvlId=="0"||itemObj.ssHistoryMtssLvlId=="Not Selected"?"Not Selected":"",
                            },

                    "isInstrLevelsChecked": (itemObj.categories) ? (itemObj.categories).includes("instrlevels") : false,
                    "instrLevels": {
                        "ELALevel": itemObj.elaInstrLvl,
                        "WritingLevel": itemObj.writingInstrLvl,
                        "MathLevel": itemObj.mathInstrLvl,
                        "ScienceLevel": itemObj.scienceInstrLvl,
                        "HistoryLevel": itemObj.ssHistoryInstrLvl,
                    },
                    
                    "isGradPlanChecked": (itemObj.categories) ? (itemObj.categories).includes("gradplan") : false,
                    "gradPlan": {
                        "diplomaAssigned": itemObj.diplomaAssigned,
                        "diplomaAssignedName": itemObj.diplomaAssignedName,
                        "cohortYear": itemObj.gradPlanCohortYears ? itemObj.gradPlanCohortYears.split(',').map(Number) : '',
                        "schoolCohortYear": itemObj.gradPlanSchoolCohortYears ? itemObj.gradPlanSchoolCohortYears.split(',').map(Number) : '',
                        "creditsEarnedQualifier": itemObj.creditsEarnedQualifier,
                        "stCreditsEarned": itemObj.stCreditsEarned,
                        "creditsNeededGradQualifier": itemObj.creditsNeededGradQualifier,
                        "stCreditsNeededGrad": itemObj.stCreditsNeededGrad,
                        "creditsInProgressQualifier": itemObj.creditsInProgressQualifier,
                        "stCreditsInProgress": itemObj.stCreditsInProgress,
                        "creditsNeededQualifier": itemObj.creditsNeededQualifier,
                        "stCreditsNeeded": itemObj.stCreditsNeeded,
                        "planLastModifiedDateQualifier": itemObj.planLastModifiedDateQualifier,
                        "planLastModifiedDate": itemObj.planLastModifiedDate,
                        "readyStuView": (itemObj.readyStuView) ? (itemObj.readyStuView.toString().charAt(0).toUpperCase() + itemObj.readyStuView.toString().slice(1)) : '',
                        "firstAccDateQualifier": itemObj.firstAccDateQualifier,
                        "firstAccDate": itemObj.firstAccDate,
                        "lastAccDateQualifier": itemObj.lastAccDateQualifier,
                        "lastAccDate": itemObj.lastAccDate,
                        "timesViewedQualifier": itemObj.timesViewedQualifier,
                        "timesViewed": itemObj.timesViewed,
                        "requirementCategory": itemObj.requirementCategory,
                        "requirementName": itemObj.gradPlanRequirementName ? itemObj.gradPlanRequirementName.split(',') : '',
                        "requirementType": itemObj.requirementType,
                        "requirementStatus": itemObj.requirementStatus,
                    },

                    "isStrongStartChecked": (itemObj.categories) ? (itemObj.categories).includes("strongstart") : false,
                    "strongStart" :{
                    	"DSPLevel": itemObj.dsp,
                    },

                    "isEngagementChecked": (itemObj.categories) ? (itemObj.categories).includes("engagement") : false,
                    "engagement" :{
                    	"activityInLast7DaysQualifier": itemObj.stActivityInLast7DaysQualifier,
                    	"stActivityInLast7Days": itemObj.stActivityInLast7Days,
                    	"lastStudentLoginQualifier": itemObj.lastStLoginQualifier,
                    	"lastStudentLoginDate": itemObj.lastStLoginDate,
                    	"lastLCLoginQualifier": itemObj.lastLCLoginQualifier,
                    	"lastLCLoginDate": itemObj.lastLCLoginDate,
                    	"lastContactQualifier": itemObj.lastContactQualifier,
                    	"lastContactDate": itemObj.lastContactDate,
                    },

                    "isFASTChecked": (itemObj.categories) ? (itemObj.categories).includes("fast") : false,
                    "fast" :{
                    	"fastRunningNoteQualifier": itemObj.fastRunningNoteQualifier,
                    	"fastRunningNoteDate": itemObj.fastRunningNoteDate,
                    	"teacherCompliancyNoteQualifier": itemObj.teacherCompliancyNoteQualifier,
                    	"teacherCompliancyNoteDate": itemObj.teacherCompliancyNoteDate,
                        "enduringConnectnCallQualifier": itemObj.enduringConnectnCallQualifier,
                        "enduringConnectnCall": itemObj.enduringConnectnCall
                    },

                    "isPulseCheckChecked": (itemObj.categories) ? (itemObj.categories).includes("pulse") : false,
                    "pulseCheck" :{
                    	"qualifier": itemObj.pulseCheckQualifier,
                    	"mostRecentPulseCheckDate": itemObj.pulseCheckDate,
                    	"plsCheckReReLikeQualifier": itemObj.plsCheckReReLikeQualifier,
                    	"plsCheckReReLike": itemObj.plsCheckReReLike,
                        "plsCheckSatisQualifier": itemObj.plsCheckSatisQualifier,
                        "plsCheckSatis": itemObj.plsCheckSatis,
                        "plsCheckPrepQualifier": itemObj.plsCheckPrepQualifier,
                        "plsCheckPrep": itemObj.plsCheckPrep,
                        "plsCheckStuSucRatQualifier": itemObj.plsCheckStuSucRatQualifier,
                        "plsCheckStuSucRat": itemObj.plsCheckStuSucRat,
                    },

                    "isReRegistrationChecked": (itemObj.categories) ? (itemObj.categories).includes("reregistration") : false,
                    "reReData" :{
                    	"reReStatus": itemObj.reReStatus ? itemObj.reReStatus.split(',') : '',
                    	"reRegLastModDateQualifier":  itemObj.reRegLastModDateQualifier,
                        "reRegLastModDate": itemObj.reRegLastModDate,
                        "reRegApprLastModDateQualifier":  itemObj.reRegApprLastModDateQualifier,
                        "reRegApprLastModDate":  itemObj.reRegApprLastModDate,
                        "reRegAprovalStatus": itemObj.reRegAprovalStatus,
                        "reRegInfoSession": (itemObj.reRegInfoSession) ? (itemObj.reRegInfoSession.toString().charAt(0).toUpperCase() + itemObj.reRegInfoSession.toString().slice(1)) : "All",
                        "reRegIOLCC":(itemObj.reRegIOLCC) ? (itemObj.reRegIOLCC.toString().charAt(0).toUpperCase() + itemObj.reRegIOLCC.toString().slice(1)) : "All",
                        "reRegLastMailTemplate": itemObj.reRegLastMailTemplate,
                        "reRegLastNoteTemplate": itemObj.reRegLastNoteTemplate
                    },

                    "isActionNeededChecked": (itemObj.categories) ? (itemObj.categories).includes("actionneeded") : false,
                    "actionNeeded" :{
                    	"followUpItemKeyword": itemObj.followupKeyword,
                    	"followUpActionQualifier": itemObj.followupActionQualifier,
                        "followUpActionDate": itemObj.followupActionDate,
                        "followUpItem": itemObj.followupItem,
                    },
                     "isMessagedChecked": (itemObj.categories) ? (itemObj.categories).includes("messaged") : false,
                     "isMessagedAcademicsChecked": (itemObj.categories) ? (itemObj.categories).includes("messagedAcademics") : false,
                      "isMessagedAttendanceChecked": (itemObj.categories) ? (itemObj.categories).includes("messagedAttendance") : false,
                      "isMessagedComplianceChecked": (itemObj.categories) ? (itemObj.categories).includes("messagedCompliance") : false,
                      "isMessagedEngagementChecked": (itemObj.categories) ? (itemObj.categories).includes("messagedEngagement") : false,
                      "isMessagedSpeProgramChecked": (itemObj.categories) ? (itemObj.categories).includes("messagedSpeProgram") : false,
                      "isMessagedStStartChecked": (itemObj.categories) ? (itemObj.categories).includes("messagedStStart") : false,
                      "isMessagedTestChecked": (itemObj.categories) ? (itemObj.categories).includes("messagedTest") : false,
                     "messaged": {
                        "admicIntConQualifier": itemObj.admicIntConQualifier,
                        "admicIntCon":   itemObj.admicIntCon, 
                        "gradTrackQualifier":  itemObj.gradTrackQualifier,
                        "gradTrack":  itemObj.gradTrack, 
                        "lowProgrQualifier":  itemObj.lowProgrQualifier,
                        "lowProgr":   itemObj.lowProgr, 
                        "retentConQualifier":  itemObj.retentConQualifier,
                        "retentCon":   itemObj.retentCon, 
                        "daysAbs10plusQualifier": itemObj.daysAbs10plusQualifier,
                        "daysAbs10plus":   itemObj.daysAbs10plus, 
                        "daysAbs1Qualifier": itemObj.daysAbs1Qualifier,
                        "daysAbs1":  itemObj.daysAbs1, 
                        "daysAbs2Qualifier":  itemObj.daysAbs2Qualifier,
                        "daysAbs2":  itemObj.daysAbs2, 
                        "daysAbs3Qualifier":  itemObj.daysAbs3Qualifier,
                        "daysAbs3":   itemObj.daysAbs3, 
                        "daysAbs4Qualifier":  itemObj.daysAbs4Qualifier,
                        "daysAbs4":  itemObj.daysAbs4, 
                        "daysAbs5Qualifier":  itemObj.daysAbs5Qualifier,
                        "daysAbs5":  itemObj.daysAbs5, 
                        "daysAbs6Qualifier":  itemObj.daysAbs6Qualifier,
                        "daysAbs6": itemObj.daysAbs6, 
                        "daysAbs7Qualifier":  itemObj.daysAbs7Qualifier,
                        "daysAbs7":  itemObj.daysAbs7, 
                        "daysAbs8Qualifier":  itemObj.daysAbs8Qualifier,
                        "daysAbs8":  itemObj.daysAbs8, 
                        "daysAbs9Qualifier":  itemObj.daysAbs9Qualifier,
                        "daysAbs9":   itemObj.daysAbs9, 
                        "daysAbs10Qualifier":  itemObj.daysAbs10Qualifier,
                        "daysAbs10":  itemObj.daysAbs10, 
                        "daysAbs11Qualifier":  itemObj.daysAbs11Qualifier,
                        "daysAbs11":  itemObj.daysAbs11, 
                        "daysAbs12Qualifier":  itemObj.daysAbs12Qualifier,
                        "daysAbs12":  itemObj.daysAbs12, 
                        "daysAbs13Qualifier":  itemObj.daysAbs13Qualifier,
                        "daysAbs13":  itemObj.daysAbs13, 
                        "daysAbs14Qualifier": itemObj.daysAbs14Qualifier,
                        "daysAbs14":  itemObj.daysAbs14, 
                        "daysAbs15Qualifier":  itemObj.daysAbs15Qualifier,
                        "daysAbs15":  itemObj.daysAbs15, 
                        "daysAbs16Qualifier":  itemObj.daysAbs16Qualifier,
                        "daysAbs16":  itemObj.daysAbs16, 
                        "daysAbs17Qualifier":  itemObj.daysAbs17Qualifier,
                        "daysAbs17":  itemObj.daysAbs17, 
                        "daysAbs18Qualifier":  itemObj.daysAbs18Qualifier,
                        "daysAbs18": itemObj.daysAbs18, 
                        "daysAbs19Qualifier":  itemObj.daysAbs19Qualifier,
                        "daysAbs19": itemObj.daysAbs19, 
                        "daysAbs20Qualifier":  itemObj.daysAbs20Qualifier,
                        "daysAbs20":   itemObj.daysAbs20, 
                        "actNoAttQualifier":  itemObj.actNoAttQualifier,
                        "actNoAtt":   itemObj.actNoAtt, 
                        "behindHrsQualifier":  itemObj.behindHrsQualifier,
                        "behindHrs":   itemObj.behindHrs, 
                        "excAbbNotQualifier":  itemObj.excAbbNotQualifier,
                        "excAbbNot":   itemObj.excAbbNot, 
                        "goodAttQualifier":   itemObj.goodAttQualifier,
                        "goodAtt":  itemObj.goodAtt, 
                        "missMoreAttNotQualifier":  itemObj.missMoreAttNotQualifier, 
                        "missMoreAttNot":  itemObj.missMoreAttNot, 
                        "nonEmailContQualifier":  itemObj.nonEmailContQualifier,
                        "nonEmailCont":  itemObj.nonEmailCont, 
                        "compDocNeedQualifier":  itemObj.compDocNeedQualifier,
                        "compDocNeed":   itemObj.compDocNeed, 
                        "compuAppQualifier":  itemObj.compuAppQualifier,
                        "compuApp":  itemObj.compuApp, 
                        "famIncFormQualifier":  itemObj.famIncFormQualifier,
                        "famIncForm":  itemObj.famIncForm,                
                        "phoneNumUpdateQualifier": itemObj.phoneNumUpdateQualifier, 
                        "phoneNumUpdate":   itemObj.phoneNumUpdate, 
                        "behaviorConQualifier":  itemObj.behaviorConQualifier, 
                        "behaviorCon":   itemObj.behaviorCon, 
                        "couLockCommuQualifier": itemObj.couLockCommuQualifier, 
                        "couLockCommu":  itemObj.couLockCommu, 
                        "limitedActQualifier":  itemObj.limitedActQualifier, 
                        "limitedAct":  itemObj.limitedAct, 
                        "lowCCAttQualifier": itemObj.lowCCAttQualifier, 
                        "lowCCAtt": itemObj.lowCCAtt, 
                        "noLoginQualifier": itemObj.noLoginQualifier, 
                        "noLogin":  itemObj.noLogin, 
                        "winbackCallQualifier": itemObj.winbackCallQualifier, 
                        "winbackCall":  itemObj.winbackCall, 
                        "engPlanCallQualifier": itemObj.engPlanCallQualifier, 
                        "engPlanCall": itemObj.engPlanCall, 
                        "meeting504Qualifier": itemObj.meeting504Qualifier, 
                        "meeting504": itemObj.meeting504, 
                        "iEPMeetingQualifier": itemObj.iEPMeetingQualifier, 
                        "iEPMeeting":  itemObj.iEPMeeting, 
                        "iripQualifier": itemObj.iripQualifier, 
                        "irip":  itemObj.irip, 
                        "tieredInstQualifier": itemObj.tieredInstQualifier, 
                        "tieredInst":  itemObj.tieredInst, 
                        "missStuConnQualifier": itemObj.missStuConnQualifier, 
                        "missStuConn":  itemObj.missStuConn, 
                        "orientationQualifier": itemObj.orientationQualifier, 
                        "orientation":  itemObj.orientation,  
                        "onboardingQualifier": itemObj.onboardingQualifier, 
                        "onboarding":  itemObj.onboarding, 
                        "stateTestAssignQualifier": itemObj.stateTestAssignQualifier, 
                        "stateTestAssign": itemObj.stateTestAssign 
                     }
                }
                // console.log("built obj", savedStudentObj);
                return savedStudentObj;
            }


    return {
    	service: service,
    	getSavedStudentObj: getSavedStudentObj
    };

}]);
    
}(angular, schoolwork12));